import ListFooterComponent from './ListFooterComponent';
export default ListFooterComponent;
